import React from 'react';
import postferment from '../../assets/images/Postfermentationddev.png'
import './PostFermentationDevelopment.css'
import { useTranslation } from 'react-i18next';

function PostFermentationDevelopment() {
  const { t } = useTranslation();

  const products = [
  
    {
      name: t('ICEvin DULCIS IN ORE'),
      description: t('Preparation based on parietal polysaccharides with various degrees of hydrolysis obtained from cell walls of Saccharomyces cerevisiae. Add to the wine and carry out two weekly batônnages to reproduce the sur-lies effect.'),
    },
    {
      name: t('ICEvin EASY ROUND'),
      description: t('Adjuvant for red and white wines. It is a preparation based on vegetable polysaccharides, condensed tannins, ellagic tannins and soluble mannoproteins. Its particular composition allows the characteristics of “volume”, “softness” and “flavour” to be enhanced in wines. It should be added to the wines two-three days before bottling.'),
    },
    {
      name: t('ICEvin EQUILIBRIO'),
      description: t('Adjuvant based on proanthocyanidin tannins extracted from the skin and seeds of non-aromatic white grapes rich in medium molecular weight polysaccharides.'),
    },
    {
      name: t('ICEvin FRESH UP'),
      description: t('An ideal adjuvant to rebalance and harmonize the tannic structure of the treated wine, smoothing out sharp edges and increasing elegance and acid perception. The limited astringency makes it a product suitable for addition to white, rosé and red wines, giving aromatic complexity, refreshing and implementing floral and balsamic scents.'),
    },
    {
        name: t('ICEvin LEVANTE'),
        description: t('Product made up of ellagic tannins from exotic woods and proanthocyanidins, with characteristics specifically designed for white and rosé wines. Its peculiar composition allows the citrus and floral notes to be enhanced, guaranteeing the wine the ability to maintain youth for long periods.'),
      },
      {
        name: t('ICEvin READY'),
        description: t('Highly soluble mannoproteins from Saccharomyces cerevisiae indicated for the tartaric stabilization of wines. Its use makes possible reactions between some polyphenolic substances responsible for the drier and bitterer notes, managing to attenuate astringency and giving greater roundness and flavor without limiting the aromatic expression of the wine.'),
      },
      {
        name: t('ICEvin READYLEES'),
        description: t('Preparation based on cell membranes extracted from Saccharomyces cerevisiae for the controlled release of mannoproteins. The quick-release components allow you to simplify cellar operations, without the need for weekly batonnage. The use of ICEvin Readylees during refinement allows you to obtain a wine with greater complexity and fullness of taste.'),
      },
      {
        name: t('ICEvin SUCROSITE ELEVAGE'),
        description: t('Product based on parietal polysaccharides, ellagic tannin from French oak and proanthocyanidin tannins, it gives volume and roundness to wines as well as acting on the structure'),
      },
      {
        name: t('ICEvin SUCROSITE TOUCH'),
        description: t('Product based on polysaccharides, proanthocyanidin and ellagic tannins. Its unique and balanced composition allows the perception of dryness to be attenuated in treated wines, increasing the sensation of volume and persistence.'),
      },
      {
        name: t('ICEvin SUCROSITE UVA'),
        description: t('Obtained from the pomace of white grapes with tannic characteristics that also allow it to be used in white and rosé wines.'),
      },
      
     
  ];

  return (
    <> 
    <div className='mainPostFDImg'>
  <div className='PostFDImg1'></div>

  <div className="PostFDImg2">
    <h1 className="PostFDTitle">{t("Post Fermentation Development")}</h1>
    <img src={postferment} alt="Post Fermentation Development" className="PostFDImage" />
  </div>
</div>
   
    <div className="main-infocontainer">
      {products.map((product, index) => (
        <div className="item-container" key={index}>
          {/* <img src={product.image} alt={product.name} /> */}
          <div className="text-info">
            <h1>{product.name}</h1>
            <p>{product.description}</p>
          </div>
        </div>
      ))}
    </div>
    </>
  );
}

export default PostFermentationDevelopment;
